import React from 'react';

import InputGroup    from '../InputGroup';
import Label         from '../Label';
import InlineError   from '../InlineError';
import Input         from '../Input';
import Button        from '../Button';

import promoCodes from '../../services/promotionCodes';

import style from './style.scss';

class PromotionCodeForm extends React.Component {

    constructor() {

        super();

        this.state = {
            promo_code: '',
            checking: false,
            inlineErrors: []
        };
    }

    _codeInputChanged(event) {

        this.setState({
            promo_code: event.target.value,
            inlineErrors: []
        });
    }

    _checkPromoCode(promoCode) {

        function checkSuccess(response) {

            this.setState({
                ...this.state,
                promo_code: '',
                checking: false
            });

            this.props.applied(response.data.data);
        }

        function checkFailed(response) {

            this.setState({
                ...this.state,
                inlineErrors: response.data.errors.code,
                checking: false
            });
        }

        this.setState({
            ...this.state,
            inlineErrors: [],
            checking: true
        });

        promoCodes.check({ code: promoCode, event_id: this.props.eventId, course_id: this.props.courseId })
            .then(checkSuccess.bind(this), checkFailed.bind(this));
    }

    render() {

        return (
            <div>

                <InputGroup>

                    <Label>Promotion Code Number</Label>

                    <Input value={ this.state.promo_code }
                           placeholder="Leave blank if not applicable"
                           onChange={ this._codeInputChanged.bind(this) }
                           errors={ this.state.inlineErrors } />

                    <InlineError errors={ this.state.inlineErrors } />

                </InputGroup>

                <Button onClick={ this._checkPromoCode.bind(this, this.state.promo_code) }
                        className={style['apply-button']}
                        disabled={ !this.state.promo_code || this.state.checking }
                        type="button">

                    <span>Apply Code</span>

                </Button>

            </div>
        );
    }
}

export default PromotionCodeForm;


// WEBPACK FOOTER //
// ./components/PromotionCodeForm/index.js